import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {TrainingProgram, EmployeeTrainingStatusSummary} from 'main/stores/training';
import {successAlert} from 'shared/tools';
import _ from 'lodash';

class TrainingSummaryContainerState {
  store = new DomainStore();
  match;
  history;
  agent;

  trainingProgram;
  deleteProgramModalOpen = false;
  launchProgramModalOpen = false;
  selectEmployeesModalOpen = false;
  reassignTrainingModalOpen = false;
  selectedEmployees = [];
  selectedEmployeeForReassignment = {};
  reassignmentDueDate;
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false,
      agent: false
    });
  }

  receiveProps({match, history}) {
    this.match = match;
    this.history = history;
  }

  async load() {
    await this.store._compose([
      endpoints.TRAINING.PROGRAM.with(this.trainingProgramId)
    ]);

    this.trainingProgram = new TrainingProgram(
      this.store._getSingle(types.TRAINING.PROGRAM)
    );
  }

  setAgent(agent) {
    this.agent = agent;
  }

  openDeleteProgramModal() {
    this.deleteProgramModalOpen = true;
  }

  openLaunchProgramModal() {
    this.launchProgramModalOpen = true;
  }

  openSelectEmployeesModal() {
    this.selectEmployeesModalOpen = true;
  }

  openReassignTrainingModal(employee) {
    this.selectedEmployeeForReassignment = employee;
    this.reassignTrainingModalOpen = true;
  }

  closeModals() {
    this.launchProgramModalOpen = false;
    this.deleteProgramModalOpen = false;
    this.selectEmployeesModalOpen = false;
    this.reassignTrainingModalOpen = false;

    this.errors = {};
  }

  async assignEmployees() {
    const statuses = _.map(this.selectedEmployees, employee => new EmployeeTrainingStatusSummary({employee}));

    const program = new TrainingProgram({
      employeeTrainingStatuses: statuses
    });

    const {model, errors} = await this.store.patch(
      this.trainingProgram.link('addAssignees'),
      types.TRAINING.PROGRAM,
      program
    );

    this.errors = errors;

    if (model) {
      this.agent.refresh();
      this.closeModals();
    }
  }

  async reassignEmployee() {
    const status = new EmployeeTrainingStatusSummary({employee: this.selectedEmployeeForReassignment});

    const program = new TrainingProgram({
      employeeTrainingStatuses: [status],
      absoluteDueDate: this.reassignmentDueDate
    });

    const {model, errors} = await this.store.patch(
      this.trainingProgram.link('addAssignees'),
      types.TRAINING.PROGRAM,
      program
    );

    this.errors = errors;

    if (model) {
      this.agent.refresh();
      this.closeModals();
    }
  }

  async removeTrainingStatus(status) {
    await this.store.destroy(status);
    await this.load();
  }

  async destroyProgram() {
    await this.store.destroy(this.trainingProgram);

    this.closeModals();
    successAlert(t('training.manage.Training program deleted.'));
    this.history.push('/admin/programs');
  }

  navigateToEdit() {
    this.history.push('edit');
  }

  customLinksFor(status) {
    if (status.hasLink('reassignTraining')) {
      return [{
        text: 'training.summary.Reassign training',
        action: status => this.openReassignTrainingModal(status.employee)
      }];
    } else {
      return [];
    }
  }

  get trainingProgramId() {
    return this.match.params.id;
  }

  get programTags() {
    const tags = [];

    if (this.trainingProgram.closed) {
      tags.push({
        colour: 'scarlet',
        content: 'training.summary.Closed'
      });
    }

    return tags;
  }
}

export default TrainingSummaryContainerState;
